import { IColumn } from "@fluentui/react";

export const isFilterableColumn = (column: IColumn): boolean => {
  return Boolean(column.fieldName) && !column.isIconOnly;
};
